import util from '@bmp-vue/core/api/util'
const controller = 'Teclift'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get () {
    return [
      { modelo: 0, prazoInicio: 1, prazoFim: 23, taxa: 1.81 },
      { modelo: 0, prazoInicio: 24, prazoFim: 35, taxa: 1.54 },
      { modelo: 0, prazoInicio: 36, prazoFim: 47, taxa: 1.52 },
      { modelo: 0, prazoInicio: 48, prazoFim: 60, taxa: 1.46 },
      { modelo: 1, prazoInicio: 1, prazoFim: 23, taxa: 2.03 },
      { modelo: 1, prazoInicio: 24, prazoFim: 35, taxa: 1.68 },
      { modelo: 1, prazoInicio: 36, prazoFim: 47, taxa: 1.62 },
      { modelo: 1, prazoInicio: 48, prazoFim: 60, taxa: 1.62 },
      { modelo: 2, prazoInicio: 1, prazoFim: 23, taxa: 2.24 },
      { modelo: 2, prazoInicio: 24, prazoFim: 35, taxa: 1.79 },
      { modelo: 2, prazoInicio: 35, prazoFim: 47, taxa: 1.70 },
      { modelo: 2, prazoInicio: 48, prazoFim: 60, taxa: 1.67 },
      { modelo: 3, prazoInicio: 1, prazoFim: 23, taxa: 2.30 },
      { modelo: 3, prazoInicio: 24, prazoFim: 35, taxa: 1.86 },
      { modelo: 3, prazoInicio: 36, prazoFim: 47, taxa: 1.77 },
      { modelo: 3, prazoInicio: 48, prazoFim: 60, taxa: 1.71 }
    ]
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
  Indexador: [
    { value: 1, text: 'CDI' },
    { value: 2, text: 'SELIC' },
    { value: 3, text: 'IPCA' },
    { value: 4, text: 'PTAX' },
    { value: 5, text: 'IGP-M' }
  ],
  GetValorRegistro: async function (th, model) {
    if (!th.$param.EST_VALORES || !th.$param.EST_VALORES.Registro || th.$param.EST_VALORES.length === 0) { return }
    const registros = th.$param.EST_VALORES.Registro
    var vlrRegistro = 0
    const dto = { parameters: [{ name: 'CodigoProposta', value: model.Codigo }] }
    th.$set(model, 'VlrRegistro', 0)
    var response = await th.$api.Multiplo.Post('ListPropostaGarantiaBem', dto)
    if (th.$api.UI.PostLoadData(response)) {
      var tipoPessoa = th.$api.UI.Format.SomenteNumeros(model.Cliente.DocumentoFederal).length === 11 ? 1 : 2
      for (var i = 0; i < response.Data.length; i++) {
        vlrRegistro += await this.GetValorRegistroGarantia(th, response.Data[i], tipoPessoa, registros)
      }
      th.$set(model, 'VlrRegistro', vlrRegistro)
    }
  },
  GetItem (modelo, prazo) {
    return ctrl.Get().find(item => item.modelo === modelo && item.prazoInicio <= prazo && item.prazoFim >= prazo)
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    return th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos })
  },
  AllowedDates (th, value) {
    if (th && value) {
      return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
    } else {
      const date = new Date(`${th} 00:00:00`)
      const dayOfWeek = date.getDay()
      const isWeekend = [0, 6].includes(dayOfWeek)
      if (!isWeekend) { return date }
    }
  },
})

export default ctrl
